import { render, staticRenderFns } from "./FilterResultCounter.vue?vue&type=template&id=9c51d892"
import script from "./FilterResultCounter.vue?vue&type=script&lang=js"
export * from "./FilterResultCounter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports